<script setup>
  const emits = defineEmits(['click'])
</script>

<template>
  <div class="back-btn" @click="emits('click')">
    <
  </div>
</template>

<style scoped lang="scss">
  .back-btn {
    width: 38px;
    height: 38px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 8px;
    background: var(--element-bg);
    cursor: pointer;
  }
</style>